import { render, staticRenderFns } from "./publicfooter.vue?vue&type=template&id=4b9e9a0f&scoped=true&"
import script from "./publicfooter.vue?vue&type=script&lang=js&"
export * from "./publicfooter.vue?vue&type=script&lang=js&"
import style0 from "./publicfooter.vue?vue&type=style&index=0&id=4b9e9a0f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b9e9a0f",
  null
  
)

export default component.exports